import Vue from "vue";
import VueRouter from "vue-router";
import store from '../store';

import i18n from "../i18n";
import goTo from 'vuetify/es5/services/goto';

//Public
import Home from "../views/public/Home.vue";
import Login from "../views/public/Login.vue";
import NotFound from "../views/public/NotFound.vue";

import axios from '@/plugins/axios'
// Private Views


Vue.use(VueRouter);

const routes = [
  { path: '/', redirect: `/${i18n.locale}` },
  {
    path: '/:lang',
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: "/:lang/",
        name: "Home",
        component: Home
      },
      {
        path:"resetPassword",
        name: "ResetPassword",
        component: () => import(/* webpackChunkName: "reset-password" */ '../views/public/ResetPassword.vue')
      },
      {
        path: "forgotPassword",
        name: "ForgotPassword",
        component: () => import(/* webpackChunkName: "forgot-password" */ '../views/public/ForgotPassword.vue')
      },
      {
        path: "login",
        name: "Login",
        component: Login,
        beforeEnter: async (to, from, next) => {
          let isLoggedIn = await store.dispatch("user/checkUserIsLoggedIn")

          if (isLoggedIn) {
            next({ name: "Dashboard", params: { lang: "de" } })
          }
          next({ params: { lang: "de" } })
        }
      },
     
      {
        path: "verification",
        name: "Verification",
        component: () => import(/* webpackChunkName: "user-verification" */ '../views/public/Verification.vue')
      },
     
      {
        path: "haftunsausschluss",
        name: "ExclusionOfLiability",
        component: () => import(/* webpackChunkName: "exclusion-of-liability" */ '../views/public/ExclusionOfLiability.vue')
      },
      {
        path: "datenschutz",
        name: "Privacy",
        component: () => import(/* webpackChunkName: "privacy" */ '../views/public/Privacy.vue')
      },
      {
        path: "impressum",
        name: "Impress",
        component: () => import(/* webpackChunkName: "impress" */ '../views/public/Impress.vue')
      },
      {
        path: "vorstand",
        name: "Vorstand",
        component: () => import(/* webpackChunkName: "vorstand" */ '../views/public/Vorstand.vue')
      },
      {
        path: "fsj",
        name: "FSJ",
        component: () => import(/* webpackChunkName: "fsj" */ '../views/public/FSJ.vue')
      },
      {
        path: "blog",
        name: "Blog",
        component: () => import(/* webpackChunkName: "blog" */ '../views/public/Blog.vue')
      },
      {
        path: "sportstaetten",
        name: "Locations",
        component: () => import(/* webpackChunkName: "locations" */ '../views/public/Locations.vue')
      },

      {
        path: "formulare",
        name: "Formulare",
        component: () => import(/* webpackChunkName: "forms" */ '../views/public/Forms.vue')
      }, {
        path: "beitrag/:id",
        name: "PostDetails",
        component: () => import(/* webpackChunkName: "post-details" */ '../views/public/PostDetails.vue')
      },
      {
        path: "volkslauf",
        name: "Volkslauf",
        component: () => import(/* webpackChunkName: "fun-run" */ '../views/public/Volkslauf.vue')
      },
      {
        path: "abteilung/:id",
        name: "Abteilungen",
        component: () => import(/* webpackChunkName: "department" */ '../views/public/Department.vue'),
        beforeEnter: async (to, from, next) => {
          try {
            await store.dispatch('department/getDepartment', to.params.id)
            next()
          } catch (error) {

            next()
          }
        },
      },
      {
        path: "workshop",
        name: "Workshops",
        component: () => import(/* webpackChunkName: "workshop" */ '../views/public/Workshop.vue')
      },
      {
        path: "account",
        component: () => import(/* webpackChunkName: "account" */ '../views/private/Account.vue'),
        meta: { requiresAuth: true },
        beforeEnter: async (to, from, next) => {
          try {
            let exists = await store.dispatch('user/exists');
            if (exists) next();
            else {
              await store.dispatch('user/removeUser');
              next({ name: Login })
            }
          } catch (error) {
            next({ name: Home })
          }
        },
        children: [
          {
            path: "/",
            name: "Dashboard",
            component: () => import(/* webpackChunkName: "dashboard" */ '../views/private/Dashboard.vue'),
            beforeEnter: async (to, from, next) => {
              if (Array.of('owner', 'admin', 'department').some(x => store.getters['user/getUser'].roles.includes(x))) next();
              else if (store.getters['user/getUser'].roles.includes('workshop')) next({ name: 'Account_Workshop', params: { lang: 'de' } })
              else if (store.getters['user/getUser'].roles.includes('course')) next({ name: 'Account_Course', params: { lang: 'de' } })
              else next({ name: 'Profile', params: { lang: 'de' } })
            },
          },
          {
            path: "beiträge",
            name: "Account_Post",
            component: () => import(/* webpackChunkName: "account-post" */ '../views/private/Post.vue'),
          },
          {
            path: "abteilungen",
            name: "Account_Department",
            component: () => import(/* webpackChunkName: "account-department" */ '../views/private/Department.vue'),
          },
          {
            path: "banners",
            name: "Banners",
            component: () => import(/* webpackChunkName: "banners" */ '../views/private/Banners.vue'),
          },
          {
            path: "support",
            name: "Support",
            component: () => import(/* webpackChunkName: "support" */ '../views/private/Support.vue'),
          },
          {
            path: "sponsoren",
            name: "Sponsors",
            component: () => import(/* webpackChunkName: "sponsors" */ '../views/private/Sponsors.vue'),
          },
          {
            path: "news",
            name: "News",
            component: () => import(/* webpackChunkName: "news" */ '../views/private/news/News.vue'),
          },
          {
            path: "veroeffentlichungen",
            name: "Publish",
            component: () => import(/* webpackChunkName: "publish" */ '../views/private/Publish.vue'),
          },
          {
            path: "angebote",
            name: "Account_Course",
            component: () => import(/* webpackChunkName: "account-course" */ '../views/private/course/Course.vue'),
          },
          {
            path: "angebot/:id",
            name: "CourseDetails",
            component: () => import(/* webpackChunkName: "account-course-details" */ '../views/private/course/CourseDetails.vue'),
            /* eslint-disable-next-line no-unused-vars */
            beforeEnter: async (to, from, next) => {
              try {

                store.dispatch('course/getCourse', to.params.id)
                let res = (await axios.get(`/api/times/${to.params.id}`)).data
                if (res.success) store.commit('course/SET_TIMES_OF_CURRENT_COURSE', res.data);
                next()
              } catch (error) {
                next()
              }
            },
          },
          {
            path: "workshop/:id",
            name: "WorkshopDetails",
            component: () => import(/* webpackChunkName: "account-workshop-details" */ '../views/private/workshop/WorkshopDetails.vue'),
            /* eslint-disable-next-line no-unused-vars */
            beforeEnter: async (to, from, next) => {
              try {

                store.dispatch('workshop/getWorkshop', to.params.id)
                let res = (await axios.get(`/api/times/${to.params.id}`)).data
                if (res.success) store.commit('workshop/SET_TIMES_OF_CURRENT_WORKSHOP', res.data);
                next()
              } catch (error) {
                next()
              }
            },
          },
          {
            path: "workshop",
            name: "Account_Workshop",
            component: () => import(/* webpackChunkName: "account-workshop" */ '../views/private/workshop/Workshop.vue'),
          }, {
            path: "profil",
            name: "Profile",
            component: () => import(/* webpackChunkName: "profile" */ '../views/private/Profile.vue'),
          }, {
            path: "sportstaetten",
            name: "AccountLocations",
            component: () => import(/* webpackChunkName: "locations" */ '../views/private/Locations.vue'),
          },
        ]
      },
    ]
  },
  { path: '*', component: NotFound },
];

const scrollBehavior = (to, from, savedPosition) => {
  let scrollTo = 0

  if (to.hash) {
    scrollTo = to.hash
  } else if (savedPosition) {
    scrollTo = savedPosition.y
  } else {
    return { x: 0, y: 0 }
  }

  return goTo(scrollTo)
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior,
  routes
});

router.beforeEach(async (to, from, next) => {

  // if (!to.path.includes('de')) to.path.replace (/^/,'de/');
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let loggedIn = await store.dispatch("user/checkUserIsLoggedIn")
    if (!loggedIn) {
      next({ name: "Login", params: { lang: "de" } })
    }
    next({ params: { lang: "de" } })
  }
  next({ params: { lang: "de" } }) // make sure to always call next()!
})

export default router;
